import React, { useState, useEffect, useRef, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import './App.css';

/**
const Home = lazy(() => import(""));
*/

/** SECTION PAGES */
import Home from "./components/pages/Home";
import SmoothScrollToTop from './components/interface/smooth_scroll_to_top/SmoothScrollToTop';

import ProjectInterior from "./components/pages/project_gallery/ProjectInterior";
import ProjectKomersial from "./components/pages/project_gallery/ProjectKomersial";
import ProjectMasjid from "./components/pages/project_gallery/ProjectMasjid";
import ProjectMasterplan from "./components/pages/project_gallery/ProjectMasterplan";
import ProjectRumah from "./components/pages/project_gallery/ProjectRumah";
import ErrorPage from './components/pages/ErrorPage';

import DefaultScrollToTop from './components/interface/default_scroll_to_top/DefaultScrollToTop';
import ContactUs from './components/pages/ContactUs';
import FreeDesign from './components/pages/FreeDesign';
import AppBlog from './components/interface/blog/AppBlog';
import About from './components/pages/About';
import Service from './components/pages/Service';
import ExampleBlog1 from './components/interface/blog/pages/blog_content/ExampleBlog1';
import AppRekanata from './components/pages/components/rekanata/AppRekanata';
import OurServiceViewAll from './components/pages/components/rekanata/pages/detail_about_page/OurServiceViewAll';
import DesignAndBuild from './components/pages/components/rekanata/pages/detail_about_page/page_section/DesignAndBuild';
import InteriorDesign from './components/pages/components/rekanata/pages/detail_about_page/page_section/InteriorDesign';
import Masjid from './components/pages/components/rekanata/pages/detail_about_page/page_section/Masjid';
import Masterplan from './components/pages/components/rekanata/pages/detail_about_page/page_section/Masterplan';
import Renovasi from './components/pages/components/rekanata/pages/detail_about_page/page_section/Renovasi';
import AppDetailPortofolioAwiligarHouse from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_awiligar_house/AppDetailPortofolioAwiligarHouse';
import AppDetailPortofolio01 from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_01/AppDetailPortofolio01';
import AppDetailPortofolioFawnHouse from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_fawn-house/AppDetailPortofolioFawnHouse';
import AppDetailPortofolioVillaHouse from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_villa_house/AppDetailPortofolioVillaHouse';
import AppDetailPortofolioYtmHouse from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_ytm_house/AppDetailPortofolioYtmHouse';
import AppDetailPortofolioYdiHouse from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_ydi_house/AppDetailPortofolioYdiHouse';
import AppDetailPortofolioDodHouse from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_dod_house/AppDetailPortofolioDodHouse';
import AppDetailPortofolioMafSd from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_maf-sd/AppDetailPortofolioMafSd';
import AppDetailPortofolioCiforHouse from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_cifor_house/AppPortofolioCiforHouse';
import AppDetailPortofolioDarussalamMosque from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_darussalam_mosque/AppDetailPortofolioDarussalamMosque';
import Portofolio from './components/pages/components/portofolio/Portofolio';

/** MASJID GALLERY PAGES */
import MasjidAceh from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_aceh/MasjidAceh';
import MasjidPadang from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_padang/MasjidPadang';
import MasjidAlWushul from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_al_wushul/MasjidAlWushul';
import MasjidCempaka from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_al_yusna_cempaka_adipura/MasjidCempaka';
import MasjidAlAzhar from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_al_azhar/MasjidAlAzhar';
import MasjidAsySyifa from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_asy_syifa/MasjidAsySyifa';
import MasjidBaitulMuslimin from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_baitul_muslimin/MasjidBaitulMuslimin';
import MasjidBumiKiaraPayung from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_bumi_kiara_payung/MasjidBumiKiaraPayung';
import MasjidCordova1 from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_cordova_1/MasjidCordova1';
import MasjidCordova2 from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_cordova_2/MasjidCordova2';
import MasjidDarulMuttaqin from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_darul_muttaqin/MasjidDarulMuttaqin';
import MasjidKafPwk from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_kaf_pwk/MasjidKafPwk';
import MasjidKalang from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_kalang/MasjidKalang';
import MasjidKalangsari from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_kalangsari/MasjidKalangsari';
import MasjidKertayasa from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_kertayasa/MasjidKertayasa';
import MasjidLela from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_lela/MasjidLela';
import MasjidMiftahurrahmah from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_miftahurrahmah/MasjidMiftahurrahmah';
import MasjidMuhajirin from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_muhajirin/MasjidMuhajirin';
import MasjidNurulislam from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_nurulislam/MasjidNurulislam';
import MasjidPacet from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_pacet/MasjidPacet';
import MasjidParigi from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_parigi/MasjidParigi';
import MasjidPondokPinang from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_pondok_pinang/MasjidPondokPinang';
import MasjidRayaBumiOrange from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_raya_bumi_orange/MasjidRayaBumiOrange';
import MasjidSmpMutiara from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_smp_mutiara/MasjidSmpMutiara';
import MasjidSragen from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_sragen/MasjidSragen';
import MasjidSukamanah from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_sukamanah/MasjidSukamanah';
import MasjidTumbuh from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_tumbuh/MasjidTumbuh';
import MasjidUjungGenteng from './components/pages/components/portofolio/design/design_masjid/portofolio_masjid/masjid_ujung_genteng/MasjidUjungGenteng';
import AppDetailPortofolioHnsPIK2House from './components/pages/components/portofolio/detail_portofolio/detail_portofolio_hns_house/AppDetailPortofolioHnsPIK2House';

import GlobalPageRefresh from './components/GlobalPageRefresh/GlobalPageRefresh';
import OurLocation from './components/ourlocation/OurLocation';

import ImageViewerApp from './components/pdfviewer/ImageViewerApp';

function App() {

  return (
    <div className="app-section">
      <Router>

        {/* Menambahkan GlobalPageRefresh di Root Component */}
        <GlobalPageRefresh />

        <DefaultScrollToTop />

        <Routes>
          <Route>
            <Route path="/" element={<Home />} />

            {/** ROUTE IMAGE FILTER GALLERY */}
            {/** <Route path="/image-archive" element={<Tabs/>} /> */}

            {/** ROUTE OUR ALL PROJECT */}

            {/** ROUTE OUR MY PROJECT */}
            <Route path="/interior-project" element={<ProjectInterior />} />
            <Route path="/commercial-project:maintenance" element={<ProjectKomersial />} />
            <Route path="/mosque-project" element={<ProjectMasjid />} />
            <Route path="/masterplan-project" element={<ProjectMasterplan />} />
            <Route path="/house-project" element={<ProjectRumah />} />

            {/** ROUTE DESIGN MASJID POP UP MODAL DETAIL PAGES*/}
            <Route path="/design-masjid-padang" element={<MasjidPadang />} />
            <Route path="/design-al-wushul" element={<MasjidAlWushul />} />
            <Route path="/design-masjid-cempaka" element={<MasjidCempaka />} />
            <Route path="/design-masjid-al-azhar" element={<MasjidAlAzhar />} />
            <Route path="/design-masjid-aceh" element={<MasjidAceh />} />
            <Route path="/design-masjid-asy-syifa" element={<MasjidAsySyifa />} />
            <Route path="/design-masjid-baitul-muslimin" element={<MasjidBaitulMuslimin />} />
            <Route path="/design-masjid-bumi-kiara-payung" element={<MasjidBumiKiaraPayung />} />
            <Route path="/design-masjid-cordova1" element={<MasjidCordova1 />} />
            <Route path="/design-masjid-cordova2" element={<MasjidCordova2 />} />
            <Route path="/design-masjid-darul-muttaqin" element={<MasjidDarulMuttaqin />} />
            <Route path="/design-masjid-kaf-pwk" element={<MasjidKafPwk />} />
            <Route path="/design-masjid-kalang1" element={<MasjidKalang />} />
            <Route path="/design-masjid-kalang2" element={<MasjidKalangsari />} />
            <Route path="/design-masjid-kertayasa" element={<MasjidKertayasa />} />
            <Route path="/design-masjid-lela" element={<MasjidLela />} />
            <Route path="/design-masjid-miftahurrahman" element={<MasjidMiftahurrahmah />} />
            <Route path="/design-masjid-muhajirin" element={<MasjidMuhajirin />} />
            <Route path="/design-masjid-nurulislam" element={<MasjidNurulislam />} />
            <Route path="/design-masjid-pacet" element={<MasjidPacet />} />
            <Route path="/design-masjid-parigi" element={<MasjidParigi />} />
            <Route path="/design-masjid-pondok-pinang" element={<MasjidPondokPinang />} />
            <Route path="/design-masjid-raya-bumi-orange" element={<MasjidRayaBumiOrange />} />
            <Route path="/design-masjid-smp-mutiara" element={<MasjidSmpMutiara />} />
            <Route path="/design-masjid-sragen" element={<MasjidSragen />} />
            <Route path="/design-masjid-sukamanah" element={<MasjidSukamanah />} />
            <Route path="/design-masjid-tumbuh" element={<MasjidTumbuh />} />
            <Route path="/design-masjid-ujung-genteng" element={<MasjidUjungGenteng />} />

            {/** ROUTE DETAILS PORTOFOLIO */}
            <Route path="/detail-project/portofolio-grand-wisata-house" element={<AppDetailPortofolio01 />} />
            <Route path="/detail-project/portofolio-cifor-house" element={<AppDetailPortofolioCiforHouse />} />
            <Route path="/detail-project/portofolio-fawn-house" element={<AppDetailPortofolioFawnHouse />} />
            <Route path="/detail-project/portofolio-awiligar-house" element={<AppDetailPortofolioAwiligarHouse />} />
            <Route path="/detail-project/portofolio-ytm-house" element={<AppDetailPortofolioYtmHouse />} />
            <Route path="/detail-project/portofolio-ydi-house" element={<AppDetailPortofolioYdiHouse />} />
            <Route path="/detail-project/portofolio-dod-house" element={<AppDetailPortofolioDodHouse />} />
            <Route path="/detail-project/portofolio-maf-sd-house" element={<AppDetailPortofolioMafSd />} />
            <Route path="/detail-project/portofolio-villa-house" element={<AppDetailPortofolioVillaHouse />} />
            <Route path="/detail-project/portofolio-hnsPIK2-house" element={<AppDetailPortofolioHnsPIK2House />} />

            <Route path="/detail-project/portofolio-darussalam-mosque" element={<AppDetailPortofolioDarussalamMosque />} />

            <Route path='/our-location' element={<OurLocation />} />
            <Route path='/contact-us' element={<ContactUs />} />

            <Route path='/about-us' element={<About />} />
            <Route path='/about-rekanata' element={<AppRekanata />} />

            <Route path='/our-service-details:id/design-and-build' element={<OurServiceViewAll />} />

            {/** ROUTE MY SERVICE */}
            <Route path='/service' element={<Service />} />

            {/** ROUTE OUR SERVICE DETAILS */}
            <Route path='/service-detail:id/design-and-build' element={<DesignAndBuild />} />
            <Route path='/service-detail:id/interior-design' element={<InteriorDesign />} />
            <Route path='/service-detail:id/masjid' element={<Masjid />} />
            <Route path='/service-detail:id/masterplan' element={<Masterplan />} />
            <Route path='/service-detail:id/renovasi' element={<Renovasi />} />

            <Route path='/free-design' element={<FreeDesign />} />
            <Route path='/blog' element={<AppBlog />} />
            <Route path='/penggunaan-bahan-material' element={<ExampleBlog1 />} />

            <Route
              path='/menata-rumah-kecil'
              element={<ImageViewerApp
                setFolderName={'menata-rumah-kecil'}
                setThumbnail={'072425-REP_StudioNata-Ebook-MenataRumahKecil-1.jpg'}
                setArticle={`Rumah Kecil, Bukan Masalah —
Asal Tertata dengan Cerdas.
Banyak keluarga muda bermimpi
memiliki rumah sendiri, namun
saat impian itu tercapai, muncul
tantangan baru: rumah terasa
sumpek, sempit, dan tidak
nyaman. Padahal rumah itu baru
dibangun beberapa bulan lalu.`}
                sePurchaseLink={'http://lynk.id/rekanata.contractors/mxq855z6w9xz'} />}
            />

            <Route
              path='/ebooks-membangun-rumah-4-kamar-di-lahan-6-meter-mungkinkah'
              element={<ImageViewerApp
                setFolderName={'membangun-rumah-4-kamar-di-lahan-6-meter-mungkinkah'}
                setThumbnail={'072425-REP_StudioNata-Ebook-MembangunRumah4KamardiLahan6Meter-Mungkinkah_page-1.jpg'}
                setArticle={`Lahan Sempit, Harapan Besar
Bagi banyak keluarga muda,
punya rumah sendiri bukan soal
mewah atau besar, tapi soal
kenyamanan, kebutuhan, dan
masa depan. Sering kali, saat
dana masih terbatas dan
keluarga mulai tumbuh, muncul
satu pertanyaan besar:
"Apa mungkin membangun
rumah 4 kamar di lahan
yang lebarnya cuma 6
meter?"`}
                sePurchaseLink={'http://lynk.id/rekanata.contractors/mzq6r5jq484r'} />}
            />

            <Route
              path='/desain-rumah-anti-gagal'
              element={<ImageViewerApp
                setFolderName={'desain-rumah-anti-gagal'}
                setThumbnail={'072425-REP_StudioNata-Ebook-DesainRumahAntigagal_page-0001.jpg'}
                setArticle={`Mendesain rumah sendiri bukanlah hal mustahil, bahkan bagi kamu
yang bukan arsitek. Dengan pemahaman dasar dan bantuan
teknologi, kamu bisa membuat rancangan rumah yang nyaman,
fungsional, dan sesuai dengan kebutuhan keluarga.
E-book ini hadir untuk membimbing kamu langkah demi langkah,
mulai dari perencanaan, sketsa denah, hingga memilih tools yang
mudah digunakan.
Harapannya, kamu bisa lebih percaya diri saat berdiskusi dengan
tukang atau kontraktor, dan menghindari kesalahan umum yang
bisa membuat pengeluaran membengkak.`}
                sePurchaseLink={'http://lynk.id/rekanata.contractors/3240eyq4mxvq'} />}
            />

            <Route
              path='/desain-rumah-islami'
              element={<ImageViewerApp
                setFolderName={'desain-rumah-islami'}
                setThumbnail={'072425-REP_StudioNata-Ebook-Desain-Rumah-Islami_pages-to-jpg-0001.jpg'}
                setArticle={`MUQODDIMAH
Rumah adalah struktur arsitektur dasar yang dimiliki setiap orang. Orang membangun
rumah berdasarkan budaya, kepercayaan, iklim, status dan preferensi mereka. Mengenai
desain arsitektur, baik Al-Quran maupun Sunnah tidak memberikan aturan rinci tentang
desain dan konstruksi rumah. Ini sama sekali bukan ketidaktahuan Islam tentang desain
hunian. Sebaliknya, pengakuan terhadap fakta bahwa adat istiadat budaya berubah dari
waktu ke waktu dan dari satu tempat ke tempat lain. Oleh karena itu, Islam
membolehkan semua rumah berhubungan dengan adat dan rancangannya sendiri
sepanjang tidak bertentangan dengan syariat Al Quran dan Sunnah.`}
                sePurchaseLink={'http://lynk.id/rekanata.contractors/5ygp55qqppn7'} />}
            />

            <Route
              path='/pintu-gerbang-kehormatan-rumah'
              element={<ImageViewerApp
                setFolderName={'pintu-gerbang-kehormatan-rumah'}
                setThumbnail={'130825-REP_StudioNata-Ebook-Pintu-Kehormatan-Rumah_page-0001.jpg'}
                setArticle={`Pintu : Penjaga Privasi dan Kehormatan
 Dalam desain rumah Islami, pintu utama
bukan sekadar akses keluar masuk. Ia
adalah gerbang pertama yang
menyambut penghuni, tamu, sekaligus
menjadi penjaga nilai-nilai yang diyakini.
Dalam rumah berlandaskan nilai-nilai
Islami, pintu utama bukan sekadar elemen
bangunan, melainkan simbol penjagaan
dan penghormatan. Ia menjadi titik awal
interaksi antara dunia luar dan ruang
pribadi sebuah keluarga. Di sinilah letak
pentingnya perencanaan yang tidak
hanya fungsional, tapi juga sarat makna.`}
                sePurchaseLink={'https://lynk.id/rekanata.contractors/928kk04522m6'} />}
            />

            {/* error page section */}
            <Route path="*" element={<ErrorPage />} />
          </Route>
        </Routes>
        {/*<SmoothScrollToTop/>*/}
      </Router>
    </div>
  );
}

export default App;